import React from "react";
import { E } from "./Emoji";
type CTAButtonProps = {
  href: string;
  children: string;
};
export function CTAButton({
  href,
  children
}: CTAButtonProps) {
  return <a href={href} className="flex w-full items-center justify-center rounded-xl bg-bright px-5 py-4 text-center text-base font-black uppercase text-white shadow-[0_0_28px_rgba(77,148,255,0.45)] transition-[transform,background-color] duration-150 ease-out hover:bg-[#6aa6ff] active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-sky/50 md:text-lg" data-id="element-25" data-mp="2kyof4y5h8h5d">
      <E data-id="element-26" data-mp="2oyfbrihoprht">{children}</E>
    </a>;
}